import { userApi } from '@/features/user/userApi';
import { adminBrokerGroupsApi } from '../brokerGroups/api/brokerGroupsApi';

/**
 * The name of a user, broker group or ledger a flag targets, for messages such as remove
 * confirmations. Reads the same cached data the chips use (getUserById, listAllBrokerGroups);
 * ledgers are already names. Falls back to the id.
 */
export const getTargetName = async (dispatch, field, id) => {
	if (field === 'users') {
		const { data: user } = await dispatch(
			userApi.endpoints.getUserById.initiate(id, { subscribe: false }),
		);
		return user?.name ?? user?.email ?? id;
	}
	if (field === 'brokerGroups') {
		const { data: brokerGroups } = await dispatch(
			adminBrokerGroupsApi.endpoints.listAllBrokerGroups.initiate(undefined, {
				subscribe: false,
			}),
		);
		return brokerGroups?.find((brokerGroup) => brokerGroup.id === id)?.name ?? id;
	}
	return id;
};
